import { ArrowSquareOutIcon } from "@phosphor-icons/react/ArrowSquareOut";
import { Icon } from "../Icons/Icon";
import { T } from "../Typography/T";

interface LinkCellProps {
  text: string | undefined;
  href: string | undefined;
  external?: boolean;
  mono?: boolean;
}

export function LinkCell({ text, href, external = true, mono }: LinkCellProps) {
  if (!text || !href) {
    return (
      <T color="faint" size="xs">
        {"\u2014"}
      </T>
    );
  }

  return (
    <a
      href={href}
      className="inline-flex items-center gap-1 text-sm text-brand-text hover:underline"
      {...(external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
    >
      <span className={mono ? "font-mono" : ""}>{text}</span>
      {external && <Icon icon={ArrowSquareOutIcon} size="xs" />}
    </a>
  );
}
